const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: '10px',
    width: '100%',
  },
  image: {
    height: '120px',
  },
  title: {
    fontSize: '16px',
    fontWeight: 400,
  },
  highlight: {
    color: theme.palette.primary.main,
  },
  description: {
    fontSize: '14px',
    fontWeight: 400,
    textAlign: 'center',
    color: '#838D98',
  },
})

export default styles
